<template>
    <section>
        <h1>Configuraciones</h1>
    </section>
</template>
<script>
    export default {
        setup () {
            return {}
            }

        }
</script>
<style scoped>
</style>
